import React from 'react';

// Components
import FormattedMessageV2 from '@/views/components/i18n/FormattedMessageV2';

type Props = {
  messageToLocalize: string;
  searchQuery?: string;
  titleToLocalize: string;
};

const EmptySearchResults = (props: Props): JSX.Element => {
  const { messageToLocalize, searchQuery, titleToLocalize } = props;

  return (
    <div className="tst-empty-search-results">
      <FormattedMessageV2 className="title" toLocalize={titleToLocalize} />
      {searchQuery && <FormattedMessageV2 className="message" toLocalize={messageToLocalize} values={{ searchQuery }} />}
    </div>
  );
};

export default EmptySearchResults;
